import PropTypes from 'prop-types';

const scrollToError = (errors) => {
  let errorID = Object.keys(errors)[0];
  if (errorID) {
    document.getElementById(errorID)?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }
};

scrollToError.propTypes = {
  errors: PropTypes.object.isRequired,
};

export default scrollToError;
